import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DmsGridTemplateBase } from '../dms-grid-template-base';
import { IrisDmsGlobalSandbox } from '@iris/common/modules/dms/sandbox/dms-global.sandbox';
import { ICellRendererParams } from 'ag-grid-community';
import { IrisDmsFolderGridActionsComponent } from '../folder-grid-actions/folder-grid-actions.component';
import { IrisFileGridActionsComponent } from '../file-grid-actions/file-grid-actions.component';
import { StrakitClickStopPropagationDirective } from '@ngx-strakit/cdk';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';

@Component({
  selector: 'iris-dms-grid-actions-template',
  imports: [
    IrisDmsFolderGridActionsComponent,
    IrisFileGridActionsComponent,
    StrakitButtonComponent,
    StrakitClickStopPropagationDirective,
  ],
  templateUrl: './dms-grid-actions-template.component.html',
  styleUrls: ['./dms-grid-actions-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridActionsTemplateComponent extends DmsGridTemplateBase {
  private readonly dmsGlobalSandbox = inject(IrisDmsGlobalSandbox);

  openContextMenu(event: MouseEvent): void {
    const options = {
      position: { x: event.clientX - 256, y: event.clientY },
    };
    this.dmsGlobalSandbox.contextMenuOpenRequest$.next({ event, data: this.data(), options });
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
